module.exports = __webpack_public_path__ + "media/images/gray-linkedin-0a8f276758641b38c5565ba3e3c27b9c.png";